<div class="overlay" *ngIf="isLoading | async">
	<div class="spinner">
		<div class="spinner-part spinner-part1"></div>
		<div class="spinner-part spinner-part2"></div>
		<img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
	</div>
</div>

<div class="container-fluid pl-0">
	<div class="container-upload">
		<div class="title">
			<p class="text-left head-text">Reset Password</p>
			<p class="text-left sub-head">Please enter your current Password and new password to reset your password
			</p>
		</div>
		<div class="row justify-content-center">
			<div class="col-4 upload-container">
				<form [formGroup]="passwordForm">
					<div class="form-group mt-3">
						<label for="currentPassword">Current Password</label>
						<div class="input-group">
							<input [type]="inputCurrentPass" class="form-control" id="currentPassword"
							[attr.value]="passwordForm.get('currentPassword')?.value"
								formControlName="currentPassword" autocomplete="off" placeholder="Current Password"
								[ngClass]="{ 'is-invalid': submitted && f['currentPassword'].errors }">
							<div class="input-group-append">
								<span class="input-group-text"><i class="bi bi-eye-slash"
										(click)="passwordCurrent('hide')" *ngIf="isHideCurrent"></i>
									<i class="bi bi-eye" (click)="passwordCurrent('show')"
										*ngIf="isShowCurrent"></i></span>
							</div>
							<div *ngIf="submitted && f['currentPassword'].errors" class="invalid-feedback">
								<div *ngIf="f['currentPassword'].errors['required']">
									Current Password is required
								</div>
							</div>
						</div>
					</div>
					<div class="form-group mt-4">
						<label for="newPassword">Enter New Password</label>
						<div style="font-size: 11px; color: rgb(51, 128, 228); margin-bottom: 3px;">
							<div [style.color]="!passwordConditions.minLength ? 'red' : 'inherit'">
							 Must be at least 8 characters long.
							</div>
							<div [style.color]="!passwordConditions.uppercase ? 'red' : 'inherit'">
							 Must include at least one uppercase letter.
							</div>
							<div [style.color]="!passwordConditions.alphanumeric ? 'red' : 'inherit'">
							 Must contain both letters and numbers (alphanumeric).
							</div>
							<div [style.color]="!passwordConditions.specialChar ? 'red' : 'inherit'">
							 Must include at least one special character (e.g., !, &#64;, #, $, etc.).
							</div>
						  </div>
						<div class="input-group">
						  <input
							[type]="inputNewPass"
							class="form-control"
							id="newPassword"
							autocomplete="off"
							formControlName="newPassword"
							placeholder="Password"
							[ngClass]="{ 'is-invalid': submitted && f['newPassword'].errors }"
							(input)="validatePasswordConditions()"
						  />
						  <div class="input-group-append">
							<span class="input-group-text">
							  <i class="bi bi-eye-slash" (click)="passwordNew('hide')" *ngIf="isHideNew"></i>
							  <i class="bi bi-eye" (click)="passwordNew('show')" *ngIf="isShowNew"></i>
							</span>
						  </div>
						  <div *ngIf="submitted && f['newPassword'].errors" class="invalid-feedback">
							<div *ngIf="f['newPassword'].errors['required']">New Password is required</div>
							<!-- <div *ngIf="f['newPassword'].errors['pattern']">Password does not match the required conditions.</div> -->
						  </div>
					  
						  
						</div>
					  </div>
					  
					<div class="form-group mt-4">
						<label for="confirmPassword">Confirm New Password</label>
						<div class="input-group">
							<input [type]="inputConfirmPass" class="form-control" id="confirmPassword"
								formControlName="confirmPassword" [attr.value]="passwordForm.get('confirmPassword')?.value"
								[ngClass]="{ 'is-invalid': submitted && f['confirmPassword'].errors }"
								autocomplete="off" placeholder="Password">
							<div class="input-group-append">
								<span class="input-group-text"><i class="bi bi-eye-slash"
										(click)="passwordConfirm('hide')" *ngIf="isHideConfirm"></i>
									<i class="bi bi-eye" (click)="passwordConfirm('show')"
										*ngIf="isShowConfirm"></i></span>
							</div>
							<div *ngIf="submitted && f['confirmPassword'].errors" class="invalid-feedback">
								<div *ngIf="f['confirmPassword'].errors['required']">
									Confirm Password is required
								</div>
							</div>
						</div>
					</div>
					<button type="submit" class="btn btn-primary btn-block mt-4 mb-4" (click)="setPassword()">Reset
						Password</button>
				</form>
			</div>
		</div>
	</div>
</div>